import React from "react";
import "./AccessCover.scss";
const AccessCover = ({ url, text }) => {
  return (
    <div
      id='AccessCover'
      style={{
        backgroundImage: `url(${url})`,
      }}
    >
      <div className='absoluteTextBox'>
        <div className='wrapper' style={{ maxWidth: "835px" }}>
          <div className='absoluteTextOnCover'>
            <h1>{text}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessCover;
